
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/habits",
      function () {
        return require("private-next-pages/habits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/habits"])
      });
    }
  